import VueRouter from 'vue-router';
import {getCode, getUrlCode} from "@/common/wxjssdk.util";

const routes = [
	{
		path: '/',
		// redirect: '/product',
		redirect: '/index',
	},
	// 首页
	{
		path: '/index',
		component: () => import('../views/index.vue'),
		meta: {
			title: '首页', // 页面标题title
			showTabbar: true, // 显示tabbar
			keepAlive: true, // 默认开启缓存，防止第一次缓存失败
		},
	},
	// 我的
	{
		path: '/my',
		component: () => import('../views/my.vue'),
		meta: {
			title: '我的', // 页面标题title
			showTabbar: true, // 显示tabbar
			// keepAlive: true, // 默认开启缓存，防止第一次缓存失败
		},
	},
	// 登录
	{
		path: '/login',
		component: () => import('../views/login.vue'),
		meta: {
			title: '登录', // 页面标题title
		},
	},
	// 个人信息
	{
		path: '/personal-information',
		component: () => import('../views/personal-information.vue'),
		meta: {
			title: '个人信息', // 页面标题title
		},
	},
	// 会员
	{
		path: '/member',
		component: () => import('../views/member.vue'),
		meta: {
			title: '会员', // 页面标题title
		},
	},
	// 无偿资料
	{
		path: '/free-information',
		component: () => import('../views/free-information.vue'),
		meta: {
			title: '无偿资料', // 页面标题title
		},
	},
	// 有偿投稿视频
	{
		path: '/paid-contribution-video',
		component: () => import('../views/paid-contribution-video.vue'),
		meta: {
			title: '有偿投稿视频', // 页面标题title
		},
	},
	// 举报
	{
		path: '/report',
		component: () => import('../views/report.vue'),
		meta: {
			title: '举报', // 页面标题title
		},
	},
	// 举报-结果
	{
		path: '/report-result',
		component: () => import('../views/report-result.vue'),
		meta: {
			title: '举报结果', // 页面标题title
		},
	},
	// 投稿-结果
	{
		path: '/submission-result',
		component: () => import('../views/submission-result.vue'),
		meta: {
			title: '投稿结果', // 页面标题title
		},
	},
	// 稿件管理
	{
		path: '/manuscript-management',
		component: () => import('../views/manuscript-management.vue'),
		meta: {
			title: '稿件管理', // 页面标题title
		},
	},
	// 搜索
	{
		path: '/search',
		component: () => import('../views/search.vue'),
		meta: {
			title: '搜索', // 页面标题title
			keepAlive: true, // 开启缓存
			// 仅前往这些页面时缓存
			toPagesKeep: [
				'/search-result',
			],
		},
	},
	// 搜索结果
	{
		path: '/search-result',
		component: () => import('../views/search-result.vue'),
		meta: {
			title: '搜索结果', // 页面标题title
			keepAlive: true, // 开启缓存
			// 仅前往这些页面时缓存
			toPagesKeep: [
				'/video-details',
				'/report',
				'/feedback',
			],
		},
	},
	// h5/视频
	{
		path: '/video',
		component: () => import('../views/video.vue'),
		meta: {
			title: 'h5/视频', // 页面标题title
			keepAlive: true, // 开启缓存
			// 仅前往这些页面时缓存
			toPagesKeep: [
				'/video-classification',
				'/video-details',
				'/report',
				'/search',
				'/free-information',
				'/paid-contribution-video',
			],
		},
	},
	// 视频-分类
	{
		path: '/video-classification',
		component: () => import('../views/video-classification.vue'),
		meta: {
			title: '视频', // 页面标题title
			keepAlive: true, // 开启缓存
			// 仅前往这些页面时缓存
			toPagesKeep: [
				'/video',
				'/video-details',
				'/report',
				'/search',
				'/free-information',
				'/paid-contribution-video',
			],
		},
	},
	// 视频详情
	{
		path: '/video-details',
		component: () => import('../views/video-details.vue'),
		meta: {
			title: '视频详情', // 页面标题title
			toTop: true, // 显示回到顶部
		},
	},
	// 意见反馈
	{
		path: '/feedback',
		component: () => import('../views/feedback.vue'),
		meta: {
			title: '意见反馈', // 页面标题title
		},
	},
	// 意见反馈-结果
	{
		path: '/feedback-result',
		component: () => import('../views/feedback-result.vue'),
		meta: {
			title: '意见反馈', // 页面标题title
		},
	},
	// 各种协议页面
	{
		path: '/agreement',
		component: () => import('../views/agreement.vue'),
		meta: {
			title: '协议', // 页面标题title
		},
	},
	// 视频
	{
		path: '/video-tab-list',
		component: () => import('../views/video-tab-list.vue'),
		meta: {
			title: '视频', // 页面标题title
		},
	},
	// 文件下载
	{
		path: '/file-download',
		component: () => import('../views/file-download.vue'),
		meta: {
			title: '文件下载', // 页面标题title
		},
	},
	// 资料
	{
		path: '/information',
		component: () => import('../views/information.vue'),
		meta: {
			title: '资料', // 页面标题title
			keepAlive: true, // 开启缓存
			// 仅前往这些页面时缓存
			toPagesKeep: [
				'/information-series',
				'/report',
				'/paid-contribution-video',
				'/information-details',
				'/information-search',
			],
		},
	},
	// 资料
	{
		path: '/information-release',
		component: () => import('../views/information-release.vue'),
		meta: {
			title: '无偿投稿资料', // 页面标题title
		},
	},
	// 资料-系列
	{
		path: '/information-series',
		component: () => import('../views/information-series.vue'),
		meta: {
			title: '资料-系列', // 页面标题title
		},
	},
	// 资料-详情
	{
		path: '/information-details',
		component: () => import('../views/information-details.vue'),
		meta: {
			title: '资料-详情', // 页面标题title
			keepAlive: true, // 开启缓存
			// 仅前往这些页面时缓存
			toPagesKeep: [
				'/information-series',
				'/report',
			],
		},
	},
	// 资料-搜索
	{
		path: '/information-search',
		component: () => import('../views/information-search.vue'),
		meta: {
			title: '资料-搜索', // 页面标题title
			keepAlive: true, // 开启缓存
			// 仅前往这些页面时缓存
			toPagesKeep: [
				'/information-details',
				'/report',
				'/feedback',
			],
		},
	},
	// 图文
	{
		path: '/image-text',
		component: () => import('../views/image-text.vue'),
		meta: {
			title: '图文', // 页面标题title
			keepAlive: true, // 开启缓存
			// 仅前往这些页面时缓存
			toPagesKeep: [
				'/report',
				'/image-text-search',
				'/image-text-details',
				'/free-information',
				'/paid-contribution-video',
			],
		},
	},
	// 图文-列表
	{
		path: '/image-text-list',
		component: () => import('../views/image-text-list.vue'),
		meta: {
			title: '图文-列表', // 页面标题title
		},
	},
	// 图文-搜索
	{
		path: '/image-text-search',
		component: () => import('../views/image-text-search.vue'),
		meta: {
			title: '图文-搜索', // 页面标题title
			keepAlive: true, // 开启缓存
			// 仅前往这些页面时缓存
			toPagesKeep: [
				'/image-text-details',
				'/report',
				'/feedback',
			],
		},
	},
	// 图文-详情
	{
		path: '/image-text-details',
		component: () => import('../views/image-text-details.vue'),
		meta: {
			title: '图文-详情', // 页面标题title
		},
	},
	// 无偿投稿文章
	{
		path: '/free-articles',
		component: () => import('../views/free-articles.vue'),
		meta: {
			title: '无偿投稿文章', // 页面标题title
		},
	},
	// 资料-我的发布
	{
		path: '/informationmy-my-release',
		component: () => import('../views/informationmy-my-release.vue'),
		meta: {
			title: '资料-我的发布', // 页面标题title
		},
	},
	// 图文-我的发布
	{
		path: '/image-text-my-release',
		component: () => import('../views/image-text-my-release.vue'),
		meta: {
			title: '图文-我的发布', // 页面标题title
		},
	},
	// 图文
	{
		path: '/image-text-tab-list',
		component: () => import('../views/image-text-tab-list.vue'),
		meta: {
			title: '图文', // 页面标题title
		},
	},
	// 资料
	{
		path: '/information-tab-list',
		component: () => import('../views/information-tab-list.vue'),
		meta: {
			title: '资料', // 页面标题title
		},
	},
	// 论坛
	{
		path: '/forum',
		component: () => import('../views/forum.vue'),
		meta: {
			title: '论坛', // 页面标题title
			showTabbar: true, // 显示tabbar
		},
	},
	// 论坛-消息
	{
		path: '/forum-message',
		component: () => import('../views/forum-message.vue'),
		meta: {
			title: '论坛-消息', // 页面标题title
		},
	},
	// 论坛-问题详情
	{
		path: '/forum-question-details',
		component: () => import('../views/forum-question-details.vue'),
		meta: {
			title: '论坛-问题详情', // 页面标题title
		},
	},
	// 论坛-我的提问
	{
		path: '/forum-my-question',
		component: () => import('../views/forum-my-question.vue'),
		meta: {
			title: '论坛-我的提问', // 页面标题title
		},
	},
	// 论坛-回复我的
	{
		path: '/forum-reply-to-me',
		component: () => import('../views/forum-reply-to-me.vue'),
		meta: {
			title: '论坛-回复我的', // 页面标题title
		},
	},
	// 论坛-我的回复
	{
		path: '/forum-my-reply',
		component: () => import('../views/forum-my-reply.vue'),
		meta: {
			title: '论坛-我的回复', // 页面标题title
		},
	},
	// 论坛-回答我的
	{
		path: '/forum-answer-me',
		component: () => import('../views/forum-answer-me.vue'),
		meta: {
			title: '论坛-回答我的', // 页面标题title
		},
	},
	// 论坛-我的评论
	{
		path: '/forum-my-comments',
		component: () => import('../views/forum-my-comments.vue'),
		meta: {
			title: '论坛-我的评论', // 页面标题title
		},
	},
	// 论坛-评论我的
	{
		path: '/forum-comment-on-my',
		component: () => import('../views/forum-comment-on-my.vue'),
		meta: {
			title: '论坛-评论我的', // 页面标题title
		},
	},
	// 论坛-搜索
	{
		path: '/forum-search',
		component: () => import('../views/forum-search.vue'),
		meta: {
			title: '论坛-搜索', // 页面标题title
		},
	},
	// 论坛-发布问题
	{
		path: '/forum-release-issues',
		component: () => import('../views/forum-release-issues.vue'),
		meta: {
			title: '论坛-发布问题', // 页面标题title
		},
	},
	// 论坛-回答问题
	{
		path: '/forum-question-answering',
		component: () => import('../views/forum-question-answering.vue'),
		meta: {
			title: '论坛-回答问题', // 页面标题title
		},
	},
	// 活动
	{
		path: '/activity',
		component: () => import('../views/activity.vue'),
		meta: {
			title: '活动', // 页面标题title
		},
	},
	// 活动-立即报名
	{
		path: '/activity-sign-up',
		component: () => import('../views/activity-sign-up.vue'),
		meta: {
			title: '活动-立即报名', // 页面标题title
		},
	},
	// 活动-立即报名-信息
	{
		path: '/activity-sign-up-information',
		component: () => import('../views/activity-sign-up-information.vue'),
		meta: {
			title: '完善信息', // 页面标题title
		},
	},
	// 活动-搜索
	{
		path: '/activity-search',
		component: () => import('../views/activity-search.vue'),
		meta: {
			title: '搜索', // 页面标题title
		},
	},
	// 活动-发布
	{
		path: '/activit-release',
		component: () => import('../views/activit-release.vue'),
		meta: {
			title: '发布活动', // 页面标题title
		},
	},
	// 招聘-详情
	{
		path: '/recruit-details',
		component: () => import('../views/recruit-details.vue'),
		meta: {
			title: '招聘-详情', // 页面标题title
		},
	},
	// 招聘-联系HR
	{
		path: '/recruit-contact',
		component: () => import('../views/recruit-contact.vue'),
		meta: {
			title: '联系HR', // 页面标题title
		},
	},
	// 招聘-搜索
	{
		path: '/recruit-search',
		component: () => import('../views/recruit-search.vue'),
		meta: {
			title: '搜索', // 页面标题title
		},
	},
	// 招聘
	{
		path: '/recruit',
		component: () => import('../views/recruit.vue'),
		meta: {
			title: '招聘', // 页面标题title
		},
	},
	// 商品
	{
		path: '/product',
		component: () => import('../views/product.vue'),
		meta: {
			title: '商品', // 页面标题title
		},
	},
	// 商品-确认订单
	{
		path: '/product-confirm-order',
		component: () => import('../views/product-confirm-order.vue'),
		meta: {
			title: '确认订单', // 页面标题title
		},
	},
	// 商品-收货地址
	{
		path: '/product-address',
		component: () => import('../views/product-address.vue'),
		meta: {
			title: '收货地址', // 页面标题title
		},
	},
	// 商品-收货地址-添加
	{
		path: '/product-address-add',
		component: () => import('../views/product-address-add.vue'),
		meta: {
			title: '收货地址-添加', // 页面标题title
		},
	},
	// 商品-购物车
	{
		path: '/product-address-shopping-cart',
		component: () => import('../views/product-address-shopping-cart.vue'),
		meta: {
			title: '购物车', // 页面标题title
		},
	},
	// 商品详情
	{
		path: '/product-details',
		component: () => import('../views/product-details.vue'),
		meta: {
			title: '商品详情', // 页面标题title
		},
	},
	// 商品-搜索
	{
		path: '/product-search',
		component: () => import('../views/product-search.vue'),
		meta: {
			title: '搜索', // 页面标题title
		},
	},
	// 商品-客服
	{
		path: '/product-customer-service',
		component: () => import('../views/product-customer-service.vue'),
		meta: {
			title: '客服', // 页面标题title
		},
	},
	// 商品-联系我们
	{
		path: '/product-contact',
		component: () => import('../views/product-contact.vue'),
		meta: {
			title: '联系我们', // 页面标题title
		},
	},
	// 供应商
	{
		path: '/supplier',
		component: () => import('../views/supplier.vue'),
		meta: {
			title: '供应商', // 页面标题title
		},
	},
	// 供应商详情
	{
		path: '/supplier-details',
		component: () => import('../views/supplier-details.vue'),
		meta: {
			title: '供应商详情', // 页面标题title
		},
	},
	// 供应商-联系
	{
		path: '/supplier-contact',
		component: () => import('../views/supplier-contact.vue'),
		meta: {
			title: '联系我们', // 页面标题title
		},
	},
	// 供应商-合集
	{
		path: '/supplier-collection',
		component: () => import('../views/supplier-collection.vue'),
		meta: {
			title: '合集内容', // 页面标题title
		},
	},
	// 供应商-搜索
	{
		path: '/supplier-search',
		component: () => import('../views/supplier-search.vue'),
		meta: {
			title: '搜索', // 页面标题title
		},
	},
	// 新闻
	{
		path: '/news',
		component: () => import('../views/news.vue'),
		meta: {
			title: '新闻', // 页面标题title
		},
	},
	// 新闻详情
	{
		path: '/news-details',
		component: () => import('../views/news-details.vue'),
		meta: {
			title: '新闻详情', // 页面标题title
		},
	},
	// 新闻搜索
	{
		path: '/news-search',
		component: () => import('../views/news-search.vue'),
		meta: {
			title: '搜索', // 页面标题title
		},
	},
	// 联系我们
	{
		path: '/news-contact',
		component: () => import('../views/news-contact.vue'),
		meta: {
			title: '联系我们', // 页面标题title
		},
	},
	// 热搜
	{
		path: '/hot-search',
		component: () => import('../views/hot-search.vue'),
		meta: {
			title: '热搜', // 页面标题title
			showTabbar: true, // 显示tabbar
			// keepAlive: true, // 默认开启缓存，防止第一次缓存失败
		},
	},
	// 需求
	{
		path: '/demand',
		component: () => import('../views/demand.vue'),
		meta: {
			title: '需求', // 页面标题title
		},
	},
	// 需求-搜索
	{
		path: '/demand-search',
		component: () => import('../views/demand-search.vue'),
		meta: {
			title: '搜索', // 页面标题title
		},
	},
	// 需求-发布
	{
		path: '/demand-release',
		component: () => import('../views/demand-release.vue'),
		meta: {
			title: '发布需求', // 页面标题title
		},
	},
	// 需求-发布-填写
	{
		path: '/demand-release-write',
		component: () => import('../views/demand-release-write.vue'),
		meta: {
			title: '发布需求-填写', // 页面标题title
		},
	},
	// 需求-结果
	{
		path: '/demand-result',
		component: () => import('../views/demand-result.vue'),
		meta: {
			title: '发布结果', // 页面标题title
		},
	},
	// 需求-详情
	{
		path: '/demand-details',
		component: () => import('../views/demand-details.vue'),
		meta: {
			title: '需求详情', // 页面标题title
		}, 
	},
	// 全局搜索
	{
		path: '/global-search',
		component: () => import('../views/global-search.vue'),
		meta: {
			title: '全局搜索', // 页面标题title
		}, 
	},
];

const router = new VueRouter({
	mode: 'hash',
	// mode: 'history',
	routes,
});
router.beforeEach((to, from, next) => {
	/* 路由发生变化修改页面title */
	if (to.meta.title) {
		document.title = to.meta.title;
	}
	// 监听路由中的code
	getUrlCode(location.href);

	next();
});

// 重写back()方法，没有页面时则返回首页
router.back = () => {
	if (window.history && (window.history.length <= 1 || window.history.state === null)) {
		router.push('/');
	} else {
		router.go(-1);
	}
}
export default router;
